import widgetsService from 'live/services/widgets'
import { addNewEditor } from '../common/editorRegister'
import i18n from 'live/services/i18n'
import rigIndicatorsReducer from './rigIndicatorsReducer'
import RigIndicatorsChart from './RigIndicatorsChart'
import { widgetWrapper } from 'live/widgets/decorators/pure'

import thumbnail from '../../../assets/img/rigstate.png'
import { Fields } from '../editor'
import AssetSelector from '../editor/fields/AssetSelector'
import React from 'react'
import Toogle from '../editor/fields/Toggle'
import NumericField from '../editor/fields/NumericField'

const type = 'rigindicators'
widgetsService.impl(
    type,
    widgetWrapper(RigIndicatorsChart, rigIndicatorsReducer, {
        mapConfigToRender(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        },
        sampleTime: 500
    })
)
widgetsService.name(type, 'Rig Indicators')
widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) at the end => @chain',
    handleOwnMissingData: true
})

// widgetsService.queryHandlerKind(type, type)

widgetsService.properties(type, {})
widgetsService.config(type, {
    verticalEnabled: false,
    numberOfVisibleAxes: 6
})

// addNewEditor(
//     {
//         type,
//         order: 11,
//         label: i18n('RigState'),
//         description: i18n('Visualize detected operation rig states'),
//         thumbnail: thumbnail
//     },
//     [
//         <Fields name={'channels'}>
//             <AssetSelector label={'Asset'} editorOnly={true} />
//         </Fields>,
//         <Fields>
//             <Toogle configField={'verticalEnabled'} label={i18n('Vertical chart')} />
//             <NumericField configField={'numberOfVisibleAxes'} label={i18n('Size of axes area')} suffix={'axis'} />
//         </Fields>
//     ]
// )
